// React
import React from "react";
// Framework
import { LocalizationIcon } from "icons";
import { useTranslate } from "localization/hooks";
import { TooltipButton } from "ui";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const HeaderButton = ({ onClick }) => {
  // Framework
  const { t } = useTranslate();
  // Render
  return (
    <TooltipButton
      tooltip={t("core:localization.headerItem.tooltip")}
      onClick={onClick}
    >
      <LocalizationIcon />
    </TooltipButton>
  );
};

export default HeaderButton;
